const moment = require("moment");

export const getDefaultDateRange = () => {
  return {
    startDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  };
};
/**
 * 🔴 이름과 달리 "전체" 가 아니라 **최근 1년**이다.
 *
 * 1회성·AI 메시지 목록의 "전체" 탭이 이 값을 보내는 바람에 1년보다 오래된 메시지가 목록에서 사라졌다
 * (2026-10-15 고객사 신고). 그 세 화면은 이제 "전체" 를 `dateRange = null`(기간 조건 없음) 로 보낸다.
 * 남은 사용처(주문 통계·진입점 통계)는 외부 API·집계 쿼리에 기간이 필요해 그대로 둔다 —
 * 새 화면에서 "전체" 의 의미로 이 함수를 쓰지 말 것.
 */
export const getAllDateRange = () => {
  const format = "YYYY-MM-DD"
  return {
    startDate: moment().subtract(1, "year").format(format),
    endDate: moment().format(format),
  };
};

export const range = (size, startAt) => {
  return [...Array(size).keys()].map((i) => i + startAt);
};

export const getMessagePrice = (messageType) => {
  if (messageType === "FW") {
    return 24;
  } else if (messageType === "FI") {
    return 22;
  } else if (messageType === "FT") {
    return 16.5;
  }  else {
    return 27.5;
  }
};

/**
 * 와이드 리스트형(FL) 아이템의 화면 라벨.
 * 카카오 와이드 리스트는 [메인 아이템 + 리스트 항목 N개] 구조라 첫 번째만 이름이 다르다.
 *
 * **두 개의 1회성 메시지 작성 화면과 검증 로직이 모두 이 함수를 쓴다** —
 * 예전에는 화면 placeholder 가 `index + 1`(→ 리스트 항목 2, 3, 4)이라 리스트 행 번호가 2부터 시작했고,
 * 검증 메시지는 또 다른 계산을 써서 번호가 어긋나 보였다(2026-07-29 피드백).
 * 이제 리스트 행은 1부터 순서대로 붙는다: 메인 아이템 / 리스트 항목 1 / 리스트 항목 2 / 리스트 항목 3.
 */
export const wideListItemLabel = (index) => index === 0 ? "메인 아이템" : `리스트 항목 ${index}`;
